import { IHttpClient } from "@ezhou/common";

import { FormulaSchema, FormulaValidationResult } from "../model/formula";

const schemaCache = new Map<string, Promise<FormulaSchema>>();

/**
 * Fetches (and caches) the root-object schema for a formula context, e.g. "transaction".
 */
export function getFormulaSchema(
  httpClient: IHttpClient,
  contextKey: string,
): Promise<FormulaSchema> {
  const cached = schemaCache.get(contextKey);
  if (cached) {
    return cached;
  }

  const request = httpClient
    .get<FormulaSchema>(`/formula/schema/${encodeURIComponent(contextKey)}`, (err: any) => {
      throw err;
    })
    .catch((err) => {
      // Do not cache failures so a later attempt can retry.
      schemaCache.delete(contextKey);
      throw err;
    });

  schemaCache.set(contextKey, request);
  return request;
}

/**
 * Compiles (server-side, without executing) an expression against a formula context and returns
 * any diagnostics. `rootObjects` lists the root-object names available to this field; the
 * expression is compiled against exactly those.
 */
export function validateFormula(
  httpClient: IHttpClient,
  contextKey: string,
  expression: string,
  rootObjects?: string[],
): Promise<FormulaValidationResult> {
  return httpClient.post<
    FormulaValidationResult,
    { contextKey: string; expression: string; rootObjects?: string[] }
  >(
    "/formula/validate",
    { contextKey, expression, rootObjects },
    (err: any) => {
      throw err;
    },
  );
}
